/**
 * 注册弹窗静态常量
 * - 五步注册流程的步骤总数、指示器短标签、标题栏副标题
 */
import type { RegisterStep } from '../../../../stores/registerStore';

/** 五步注册流程总步数 */
export const REGISTER_STEP_TOTAL = 5;

/** 步骤指示器短标签（按步骤序号） */
export const REGISTER_STEP_LABELS: Record<RegisterStep, string> = {
  1: '必读',
  2: '信息',
  3: '检测',
  4: '密码',
  5: '完成',
};

/** 顶部标题栏副标题（按步骤序号） */
export const REGISTER_STEP_TITLES: Record<RegisterStep, string> = {
  1: '请阅读并同意注册协议',
  2: '请填写身份信息并完成双重验证',
  3: '系统检测',
  4: '设置账号信息',
  5: '注册完成',
};